import EventHubMixin from '@/mixins/EventHub.js'
import APIMixin from '@/mixins/API.js'

export default
{
    name: 'app-cookies-bar',

    mixins:
    [
        EventHubMixin,
        APIMixin
    ],

    data()
    {
        return {
            active: null,
            content: null
        }
    },

    watch:
    {
        $route()
        {
            if(this.state === null)
            {
                this.accept()
            }
            else if(this.state === 'accepted')
            {
                if(typeof gtag === 'function')
                {
                    console.log(this.$root.config.analyticsId)
                    window.gtag('config', this.$root.config.analyticsId, { page_path: window.location.pathname }) // eslint-disable-line

                    console.log(`%cAnalytics %c> %c${this.$root.config.analyticsId} %c> %c${window.location.pathname}`, 'color: #bada55', '', 'color: #bada55', '', 'color: #bada55')
                }
            }
        },

        active()
        {
            if(this.active)
            {
                if(this.content)
                {
                    this.$eventHub.$emit('cookies.active')
                }
            }
            else
            {
                this.$eventHub.$emit('cookies.inactive')
            }
        },

        content()
        {
            if(this.active)
            {
                this.$eventHub.$emit('cookies.active')
            }
        }
    },

    created()
    {
        this.state = null

        // Set state from localStorage
        const localCookies = window.localStorage.getItem('cookies')
        if(localCookies)
        {
            if(localCookies === 'accepted')
            {
                this.state = 'accepted'
                this.active = false
                this.addGooglenAnalytics()
            }
            else if(localCookies === 'refused')
            {
                this.state = 'refused'
                this.active = true
            }
        }
        else
        {
            this.active = true
        }

        // Load content if active
        if(this.active)
        {
            this.fetch('pages', { slug: 'general', per_page: 1000 }, (data, error) =>
            {
                // Error
                if(error === true || data.length < 1)
                {
                    return
                }

                this.content = data[0]
            })
        }
    },

    methods:
    {
        onAcceptClick()
        {
            this.accept()
        },

        onRefuseClick()
        {
            this.refuse()
        },

        accept()
        {
            // Already accepted
            if(this.state === 'accepted')
            {
                return
            }

            // Update
            this.active = false
            this.state = 'accepted'
            window.localStorage.setItem('cookies', 'accepted')
            this.addGooglenAnalytics()
        },

        refuse()
        {
            // Already refused
            if(this.state === 'refused')
            {
                return
            }

            // Update
            this.active = false
            this.state = 'refused'
            window.localStorage.setItem('cookies', 'refused')
        },

        addGooglenAnalytics() /* eslint-disable */
        {
            const script1 = document.createElement('script')
            script1.setAttribute('async', '')
            script1.src = `https://www.googletagmanager.com/gtag/js?id=${this.$root.config.analyticsId}`
            document.querySelector('head').appendChild(script1)

            const script2 = document.createElement('script')
            script2.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());

                gtag('config', '${this.$root.config.analyticsId}');
            `
            document.querySelector('head').appendChild(script2)

            // window.dataLayer = window.dataLayer || []
            // window.gtag = function()
            // {
            //     window.dataLayer.push(arguments)
            // }
            // gtag('js', new Date())
            // gtag('config', this.$root.config.analyticsId)

            console.log(`%cAnalytics %c> %cInit %c> %c${this.$root.config.analyticsId}`, 'color: #bada55', '', 'color: #bada55', '', 'color: #bada55')
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-cookies-bar/script.js